<template>
  <div class="page">
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" :subNavTitle="labelNewAccountMember" ReturnButton></page-nav-bar>
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <f7-icon f7="person_round"></f7-icon>
                      {{ $t('businessMembers.add_member') }}
                  </h4>
              </div>

              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label"><span class="color-red">* </span>Login</label>
                  <div class="col-7 col-sm-10">
                    <input class="form-control" placeholder="Login" v-model="login"></input>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">Request to Pay</label>
                  <div class="col-7 col-sm-10">
                    <select class="form-control" name="clearance_payments" v-model="clearance_payments">
                      <option value="0">No Access</option>
                      <option value="3">User</option>
                      <option value="1">Administrator</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">Modular Credit</label>
                  <div class="col-7 col-sm-10">
                    <select class="form-control" name="clearance_directDebit" v-model="clearance_directDebit">
                      <option value="0">No Access</option>
                      <option value="3">User</option>
                      <option value="1">Administrator</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">Direct Payments</label>
                  <div class="col-7 col-sm-10">
                    <select class="form-control" name="clearance_directPayments" v-model="clearance_directPayments">
                      <option value="0">No Access</option>
                      <option value="3">User</option>
                      <option value="1">Administrator</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-2 offset-md-9" :class="colorBottomButton">
            <button round
            class="button-action firstButtonMarginTop"
            @click="addAccountMember">
              <f7-icon f7="add"></f7-icon>
              <span>Add</span>
            </button>
          </div>
        </div>
      </div>

      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddAccountMember',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      labelNewAccountMember: this.$i18n.t('businessMembers.new_member'),
      login: '',
      status: '',
      clearance_payments: '0',
      clearance_directDebit: '0',
      clearance_directPayments: '0',
      clear: {}
    }
  },
  created () {
    this.clear = this.$engine.user.get().clearance
  },
  methods: {
    addAccountMember () {
      this.$f7.showPreloader('')
      const that = this
      if (that.login !== '') {
        that.$engine.accounts.addUserToAccount(this.login, this.clearance_payments, this.clearance_directDebit, this.clearance_directPayments)
          .then(response => {
            if (response.status === 200) {
              that.$f7.hidePreloader()
              this.$f7.closeModal()
              that.$f7.alert('User correctly added', 'Success')
              this.$bus.$emit('refresh-cache-account-members')
              loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
            }
          })
          .catch(err => {
            errorMessageAlert(err, that)
          })
      } else {
        this.$f7.hidePreloader()
        this.$f7.alert('', 'Data empty')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// CMAddAccountMember.vue?91865a04